import React from 'react';
import { S as Skeleton } from './Skeleton-RKr5mJai.js';

const ItemSekeleton = () => (React.createElement("div", { className: "shopping-bag-item", style: { alignItems: 'flex-start' } },
    React.createElement("div", { className: "product-quantity" },
        React.createElement(Skeleton, { width: "50%", marginBottom: 0 })),
    React.createElement("div", { className: "shopping-bag-item-info" },
        React.createElement(Skeleton, { width: "40%" }),
        React.createElement(Skeleton, { width: "30%", marginBottom: 0 })),
    React.createElement("div", { className: "shopping-bag-item-price" },
        React.createElement(Skeleton, { width: "70%", marginBottom: 0 }))));

export { ItemSekeleton as I };
//# sourceMappingURL=ItemSkeleton-03cEVH7e.js.map
